import React from "react";
import { ModalAlert } from "../../common/dialog/modalAlert";
import { GraficoSaldoGeracao } from "./GraficoSaldoGeracao";

export function ModalGraficoSaldos(props) {
    if (!props.visible) return null;

    return (
        <ModalAlert titulo="" handleClose={props.handleClose} maxWidth={"95%"}>
            <GraficoSaldoGeracao registro={props.state.itemSelecionado} listaGraficoGeracaoSaldo={props.listaGraficoGeracaoSaldo} gerarRelatorio={props.gerarRelatorio} />
        </ModalAlert>
    );
}
